import { render } from "./CommandCenterComponent.vue?vue&type=template&id=b8d653b6"
import script from "./CommandCenterComponent.vue?vue&type=script&lang=js"
export * from "./CommandCenterComponent.vue?vue&type=script&lang=js"

import "./CommandCenterComponent.vue?vue&type=style&index=0&id=b8d653b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__